import styled, {css} from "styled-components";

export const Tabs = styled.div`
    text-align: left;
`

export const Glider = styled.div`
  position: absolute;
  display: flex;
  height: 54px;
  width: 200px;
  background-color: rgba(179, 55, 108, 1);
  z-index: 1;
  border-radius: 99px; 
  transition: 0.25s ease-out;
`

export const TabsMenu = styled.div`
  display: flex;
  padding: 2px;
  border-radius: 40px;
  width: fit-content;
  margin: auto;
  background: rgba(224, 224, 224, 0.5);
  cursor: pointer;
`

export const TabMenuItem = styled.div<{isActive: boolean}>`
  padding: 20px;
  border-radius: 40px;
  opacity: 0.9;

  font-size: 22px;
  font-weight: 400;
  line-height: 30px;
  text-align: center;

  ${({isActive}) => isActive
      ? css`
        background: rgba(179, 55, 108, 1);
        color: white;
      `
      : css`opacity: 0.5`
};
`

export const TabsContent = styled.div`
  margin-top: 20px;
`